var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#D86570"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.7143H13.8095V29H10V14.7143ZM11.8933 12.8095H11.8724C10.7352 12.8095 10 11.9619 10 10.9038C10 9.82286 10.7581 9 11.9152 9C13.0743 9 13.7876 9.82286 13.8095 10.9038C13.8095 11.9619 13.0743 12.8095 11.8933 12.8095ZM30 19.9524C30 17.059 27.6552 14.7143 24.7619 14.7143C22.9886 14.7143 21.4238 15.5981 20.4762 16.9467V14.7143H16.6667V29H20.4762V21.381C20.4762 19.8029 21.7552 18.5238 23.3333 18.5238C24.9114 18.5238 26.1905 19.8029 26.1905 21.381V29H30C30 29 30 20.3533 30 19.9524Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedin-logo.60ddbb5ad7ddf30516ba66a29373e861.svg";
export { ForwardRef as ReactComponent };